<template>
  <div class="login-page">
    <div class="login-content">
      <div class="top">
        <img src="@/assets/images/logo.png" class="logo" />
      </div>
      <div :class="active != 1 ? 'int_num' : 'int_num int_num_active'">
        <img
          class="icon_phone"
          src="@/assets/images/icon_phone.png"
          alt="icon_phone"
        />
        <input
          type="number"
          placeholder="请输入手机号"
          maxlength="11"
          v-model="passwordData.mobile"
          @focus="active = 1"
          @blur="active = ''"
        />
      </div>
      <div :class="active != 2 ? 'int_num' : 'int_num int_num_active'">
        <img
          class="icon_msmCode"
          src="@/assets/images/icon_msmCode.png"
          alt="icon_password"
        />
        <input
          type="password"
          placeholder="请输入密码"
          v-model="passwordData.user_pass"
          @focus="active = 2"
          @blur="active = ''"
        />
      </div>
      <div class="others">
        <img
          :src="isRememberMe ? check_hover : check_default"
          @click="isRememberMe = !isRememberMe"
          alt
        />

        <span class="remember"> 记住我 </span>
        <span class="forget" @click="forgot">忘记密码</span>
        <span class="login_CAPTCHA" @click="$router.go(-1)"
          >注册/验证码登录</span
        >
      </div>
    </div>
    <div class="login">
      <p class="login-btn" @click="goLogin">登录</p>
      <div class="login-info">
        <img
          :src="checked ? check_hover : check_default"
          @click="checked = !checked"
          alt
        />
        <p>我同意</p>
        <router-link
          :to="{ name: 'Treaty', query: { name: 'user_register_contract' } }"
          >用户注册协议</router-link
        >
        <p>和</p>
        <router-link
          :to="{ name: 'Treaty', query: { name: 'user_protect_contract' } }"
          >隐私保护协议</router-link
        >
      </div>
    </div>
    <div class="otherLogin" v-if="showOther">
      <p>第三方登录</p>
      <div class="txLogin">
        <div class="wxLogin" @click="qqLogin(1)">
          <img src="@/assets/images/wechat.png" />
          <span>微信登录</span>
        </div>
        <div class="qqLogin" @click="qqLogin(2)">
          <img src="@/assets/images/QQ.png" alt />
          <span>QQ登录</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { storageKeys, saveData, loadData, removeData } from "@/util/storage";

export default {
  data() {
    return {
      passwordData: {
        mobile: "",
        user_pass: "",
      },
      active: "",
      showOther: false,
      checked: true,
      check_hover: require("../../assets/images/question-checkbox-hover.png"),
      check_default: require("../../assets/images/un-select.png"),
      isRememberMe: false,
    };
  },
  computed: mapState(["config"]),
  methods: {
    rememberMe() {
      if (this.isRememberMe) {
        saveData(storageKeys.account, this.passwordData.mobile);
        saveData(storageKeys.password, this.passwordData.user_pass);
        saveData(storageKeys.isRememberMe, this.isRememberMe);
      } else {
        removeData(storageKeys.account);
        removeData(storageKeys.password);
        removeData(storageKeys.isRememberMe);
      }
    },
    goLogin() {
      if (!this.checked) {
        this.$toast("请勾选协议");
        return;
      }
      if (!this.$pub.isPoneAvailable(this.passwordData.mobile)) {
        this.$toast("手机号码格式不正确");
        return;
      }
      let deviceType = "H5";
      if (this.$pub.isWeiXin()) {
        deviceType = "WXH5";
      }
      this.$http
        .post(
          "/api/app/login",
          {
            mobile: this.passwordData.mobile,
            password: this.passwordData.user_pass,
            type: 1,
          },
          deviceType
        )
        .then((res) => {
          this.rememberMe();
          localStorage.setItem("adminToken", res.remember_token);
          localStorage.setItem("user_id", res.id);
          let group_id;
          if (localStorage.getItem("group_id")) {
            group_id = localStorage.getItem("group_id");
            let params = { group_id };
            if (localStorage.getItem(group_id)) {
              let uid = localStorage.getItem(group_id);
              uid = JSON.parse(uid);
              params.invite_uid = uid.inviter_uid;
              params.join_from = uid.from;
            }
            this.$router.push({
              name: "GroupDetail",
              query: params,
            });
          } else {
            if (
              localStorage.getItem("redirect") &&
              localStorage.getItem("redirect") !== "/"
            ) {
              this.$router.push({
                path: localStorage.getItem("redirect"),
              });
            } else if (
              (localStorage.getItem("redirect") &&
                localStorage.getItem("redirect") == "/") ||
              window.history.length <= 2
            ) {
              this.$router.push({
                name: "Person",
              });
            } else {
              this.$router.go(-2);
            }
          }
          setTimeout(() => {
            this.$pub.setClassify();
            localStorage.removeItem("group_id");
            if (group_id) {
              localStorage.removeItem(group_id);
            }
            this.$store.dispatch("getPerson");
          }, 500);
        });
    },
    forgot() {
      this.$router.push({
        name: "ForgetPass",
      });
    },
    qqLogin(type) {
      if (type === 1) {
        this.$pub.thirdpartLogin("wx");
      } else {
        this.$pub.thirdpartLogin("qq");
      }
    },
  },
  mounted() {
    localStorage.removeItem("adminToken");
    localStorage.removeItem("user_id");
    const account = loadData(storageKeys.account);
    const password = loadData(storageKeys.password);
    const isRememberMe = loadData(storageKeys.isRememberMe);
    if (isRememberMe) {
      this.isRememberMe = isRememberMe;
      this.passwordData.user_pass = password;
      this.passwordData.mobile = account;
    }
  },
};
</script>
<style scoped lang="scss">
.login-page {
  overflow: hidden;
}
.login-content {
  padding: 0 80px;
  overflow: hidden;
}
.top {
  margin: 150px auto;
  width: 500px;
  margin-bottom: 130px;
  .logo {
    display: block;
    width: 100%;
  }
  h4 {
    font-size: 48px;
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    color: rgba(89, 89, 89, 1);
    margin-top: 160px;
  }
}
input::-webkit-input-placeholder {
  /* placeholder颜色  */
  color: rgba(190, 190, 190, 1);
}
.int_num {
  height: 100px;
  background-color: #fff;
  border-bottom: 1px solid #f1f1f1;
  position: relative;
  input {
    box-sizing: border-box;
    padding: 30px 0;
    border: 0;
    width: 540px;
    height: 100%;
    font-size: 30px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    line-height: 40px;
    float: left;
    outline: none;
    margin-left: 50px;
  }
  .icon_phone,
  .icon_msmCode {
    position: absolute;
    width: 24px;
    height: 36px;
    top: 33px;
  }
  .icon_msmCode {
    width: 30px;
    height: 32px;
  }
}
.int_num_active {
  border-color: $theme_color;
}
.login {
  height: 374px;
  // background: url("../../assets/theme-img/login-btn.png");
  // background-size: 100% 100%;
  text-align: center;
  .login-btn {
    background-color: $theme_color;
    display: inline-block;
    width: 619px;
    height: 90px;
    line-height: 90px;
    margin-top: 110px;
    letter-spacing: 4px;
    font-size: 28px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
    border-radius: 8px;
  }
  .login-info {
    display: flex;
    padding-top: 60px;
    width: 580px;
    margin: 0 auto;
    align-items: center;
    img {
      width: 30px;
      height: 30px;
      margin-right: 10px;
    }
    p {
      font-size: 24px;
      color: #595959;
      line-height: 40px;
    }
    a {
      font-size: 24px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      color: $theme_color;
      line-height: 40px;
    }
  }
}
.others {
  width: 100%;
  margin-top: 30px;
  display: flex;
  justify-content: flex-start;
  img {
    width: 30px;
    height: 30px;
    margin-right: 10px;
  }
  .remember {
    font-size: 24px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: rgba(153, 153, 153, 1);
    margin-right: 1rem;
  }
  .forget {
    font-size: 24px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: rgba(153, 153, 153, 1);
    margin-right: 1rem;
  }
  .login_CAPTCHA {
    font-size: 24px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: rgba(153, 153, 153, 1);
  }
}
.otherLogin {
  width: 100%;

  p {
    font-size: 28px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: rgba(183, 183, 183, 1);
    text-align: center;
  }
  .txLogin {
    display: flex;
    margin-top: 80px;
    .wxLogin,
    .qqLogin {
      width: 50%;
      @extend %flex-center;
      img {
        margin-right: 20px;
      }
      span {
        font-size: 28px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(140, 140, 140, 1);
      }
    }
    .wxLogin {
      border-right: 1px solid #f1f1f1;
    }
    .wxLogin img {
      width: 48px;
      height: 38px;
    }
    .qqLogin img {
      width: 44px;
      height: 44px;
    }
  }
}
</style>
